"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignConfirmationCampaignToJSON = exports.CampaignConfirmationCampaignFromJSONTyped = exports.CampaignConfirmationCampaignFromJSON = exports.instanceOfCampaignConfirmationCampaign = void 0;
var runtime_1 = require("../runtime");
var ServiceChargesDetails_1 = require("./ServiceChargesDetails");
/**
 * Check if a given object implements the CampaignConfirmationCampaign interface.
 */
function instanceOfCampaignConfirmationCampaign(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignConfirmationCampaign = instanceOfCampaignConfirmationCampaign;
function CampaignConfirmationCampaignFromJSON(json) {
    return CampaignConfirmationCampaignFromJSONTyped(json, false);
}
exports.CampaignConfirmationCampaignFromJSON = CampaignConfirmationCampaignFromJSON;
function CampaignConfirmationCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'placedAt': !(0, runtime_1.exists)(json, 'placed_at') ? undefined : json['placed_at'],
        'totalItemsQuantity': !(0, runtime_1.exists)(json, 'total_items_quantity') ? undefined : json['total_items_quantity'],
        'subtotal': !(0, runtime_1.exists)(json, 'subtotal') ? undefined : json['subtotal'],
        'shipping': !(0, runtime_1.exists)(json, 'shipping') ? undefined : json['shipping'],
        'tax': !(0, runtime_1.exists)(json, 'tax') ? undefined : json['tax'],
        'totalCollectedOnline': !(0, runtime_1.exists)(json, 'total_collected_online') ? undefined : json['total_collected_online'],
        'serviceChargesDetails': !(0, runtime_1.exists)(json, 'service_charges_details') ? undefined : (0, ServiceChargesDetails_1.ServiceChargesDetailsFromJSON)(json['service_charges_details']),
    };
}
exports.CampaignConfirmationCampaignFromJSONTyped = CampaignConfirmationCampaignFromJSONTyped;
function CampaignConfirmationCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'placed_at': value.placedAt,
        'total_items_quantity': value.totalItemsQuantity,
        'subtotal': value.subtotal,
        'shipping': value.shipping,
        'tax': value.tax,
        'total_collected_online': value.totalCollectedOnline,
        'service_charges_details': (0, ServiceChargesDetails_1.ServiceChargesDetailsToJSON)(value.serviceChargesDetails),
    };
}
exports.CampaignConfirmationCampaignToJSON = CampaignConfirmationCampaignToJSON;
